import { useEffect, useRef, useState } from "react";
import { FaCopy, FaEye, FaEyeSlash, FaLock, FaShieldAlt } from "react-icons/fa";
import { API_CORE } from "../../../../../_CORE/API/ApiCORE";
import { REACT_HOT_TOAST_ERROR, REACT_HOT_TOAST_SUCCESS } from "../../../../../_CORE/HELPERS/reactHotToast.helper";
import { AppModal } from "../../../../../_CORE/APP/Templates/_UI/Modal/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { FieldInput } from "../../../../../_CORE/APP/Templates/_UI/Form/_index";
import { SAVINGS_CONSTANTS } from "../_MODULES/_API";

const FIELD_LABELS = { alias: "Alias", cbuCvu: "CBU / CVU", accountNumber: "Número de cuenta", username: "Usuario" };

export const SavingsSecureAccountModal = ({ isOpen, onClose, account = null }) => {
    const [pin, setPin] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState({});
    const hideTimerRef = useRef(null);

    useEffect(() => {
        if (hideTimerRef.current) { window.clearTimeout(hideTimerRef.current); hideTimerRef.current = null; }
        if (!isOpen) return undefined;
        setPin(""); setData(null); setVisible({});
        return () => {
            if (hideTimerRef.current) { window.clearTimeout(hideTimerRef.current); hideTimerRef.current = null; }
        };
    }, [isOpen, account?.id]);

    const reveal = async () => {
        if (!account?.id || (account.requiresPin && pin.length < 4)) return;
        setLoading(true);
        try {
            const response = await API_CORE.SERVICES.POST_RESOURCE(API_CORE.ENDPOINTS[SAVINGS_CONSTANTS.ACCOUNT_REVEAL], { accountId: account.id, accessPin: pin || undefined });
            if (response?.success === false) {
                REACT_HOT_TOAST_ERROR(response?.message || response?.detail || "No se pudieron revelar los datos protegidos.");
                return;
            }
            const payload = response?.data ?? null;
            setData(payload);
            if (hideTimerRef.current) window.clearTimeout(hideTimerRef.current);
            hideTimerRef.current = window.setTimeout(() => { setData(null); setVisible({}); hideTimerRef.current = null; }, 60000);
        } catch (error) {
            REACT_HOT_TOAST_ERROR(error?.response?.data?.message || "No se pudieron revelar los datos protegidos.");
        } finally { setLoading(false); }
    };

    const copy = async (value) => {
        if (!value) return;
        try {
            await navigator.clipboard.writeText(value);
            REACT_HOT_TOAST_SUCCESS("Copiado");
        } catch {
            REACT_HOT_TOAST_ERROR("No se pudo copiar al portapapeles.");
        }
    };

    return (
        <AppModal isOpen={isOpen} onClose={onClose} size="md" title="Datos protegidos" description={account?.name || "Cuenta"}
            footer={<AppButton variant="ghost" tone="neutral" onClick={onClose}>Cerrar</AppButton>}>
            <div className="LStudio__savings_secure_reader">
                <div className="LStudio__savings_helpbox"><FaShieldAlt /><div><strong>No quedan visibles</strong><p>Los valores se descifran solo para esta vista y se vuelven a ocultar automáticamente después de 60 segundos.</p></div></div>
                {!data && <div className="LStudio__savings_unlock_box">
                    {account?.requiresPin ? <FieldInput id="savings_secure_pin" type="password" label="PIN de la cuenta" value={pin} onChange={(event) => setPin(event.target.value)} placeholder="Ingresá tu PIN" autoComplete="off" /> : <p><FaLock /> Esta cuenta no tiene PIN configurado.</p>}
                    <AppButton icon={<FaEye />} onClick={reveal} isLoading={loading} isDisabled={!!account?.requiresPin && pin.length < 4}>Revelar datos</AppButton>
                </div>}
                {data && <div className="LStudio__savings_secret_list">
                    {Object.entries(FIELD_LABELS).map(([key, label]) => {
                        const value = data?.[key]; if (!value) return null;
                        const isVisible = !!visible[key];
                        return <div key={key} className="LStudio__savings_secret_row"><div><small>{label}</small><strong>{isVisible ? value : "••••••••••••"}</strong></div><div><AppButton variant="ghost" tone="neutral" isIconOnly icon={isVisible ? <FaEyeSlash /> : <FaEye />} aria-label={isVisible ? "Ocultar" : "Mostrar"} onClick={() => setVisible((current) => ({ ...current, [key]: !current[key] }))} /><AppButton variant="ghost" tone="neutral" isIconOnly icon={<FaCopy />} aria-label="Copiar" onClick={() => copy(value)} /></div></div>;
                    })}
                    {!Object.keys(FIELD_LABELS).some((key) => data?.[key]) && <p className="LStudio__savings_empty_inline">Esta cuenta no tiene datos identificatorios protegidos.</p>}
                </div>}
            </div>
        </AppModal>
    );
};
